class RecentSearches extends HTMLElement {
    constructor() {
        super();

        this.container = this.closest("#recent-searches-container");
        this.displayRecentSearches();
        this.listenToSearchResultClicks();
    }

    listenToSearchResultClicks() {
        document.addEventListener("click", (e) => {
            const link = e.target;
            const term = link?.getAttribute("data-search-result-item-link");
            if (term) {
                RecentSearches.addRecentSearch(link.getAttribute(term), link.getAttribute("href"));
            }
        });
    }

    /**
     * Static as we only need one instance of recent searches everywhere
     */
    static addRecentSearch(term, url) {
        const maxRecentSearches = window.recentlySearchedSettings.saveCount;
        const searches = RecentSearches.getRecentSearches();

        localStorage.setItem("recent-searches", JSON.stringify([
            { term, url },
            ...searches,
        ].slice(0, maxRecentSearches)));
    }

    static getRecentSearches() {
        let searches = [];
        const previouslySavedRecentSearches = localStorage.getItem("recent-searches");
        if (previouslySavedRecentSearches) {
            searches = JSON.parse(previouslySavedRecentSearches);
        }

        return searches;
    }

    static overridePredictiveSearchResultLinks() {
        const overridableLinks = document.querySelectorAll("[data-search-result-item]");
        for (const linkContainer of overridableLinks) {
            const anchor = linkContainer.querySelector("a[data-search-result-item-for]");
            anchor.addEventListener("click", (e) => {
                e.preventDefault();
            });

            linkContainer.addEventListener("click", (e) => {
                e.preventDefault();

                const term = anchor.getAttribute("data-search-result-item-for");
                const url = anchor.getAttribute("href");
                RecentSearches.addRecentSearch(term, url);
                window.location.href = url;
            });
        }
    }

    displayRecentSearches() {
        let searches = RecentSearches.getRecentSearches();
        const maxRecentSearches = window.recentlySearchedSettings.limitRecentResults || 0;
        searches = searches.slice(0, maxRecentSearches);
        

        const template = document.getElementById("recent-search-item")
        this.innerHTML = "";
        for (const search of searches) {
            const li = template.content.cloneNode(true);
            li.querySelector(".-title").innerHTML = search.term;
            li.querySelector("a.link").setAttribute("href", search.url);
            this.append(li);
        }

        this.showContainer(searches.length > 0);
    }

    showContainer(show) {
        if (show) {
            this.container.classList.remove("hidden");
        } else {
            this.container.classList.add("hidden");
        }
    }
}

customElements.define('recent-searches', RecentSearches);